import React from 'react';
import { Dropdown, Button, Avatar, Space, Menu } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined, LogoutOutlined, LoginOutlined, ProfileOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserMenu: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleMenuClick: MenuProps['onClick'] = async ({ key }) => {
    switch (key) {
      case 'profile':
        navigate('/auth/profile');
        break;
      case 'logout':
        await logout();
        break;
      case 'login':
        navigate('/auth/login');
        break;
    }
  };

  const authenticatedMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <ProfileOutlined />,
      label: '个人中心',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '注销登录',
      danger: true,
    },
  ];

  const unauthenticatedMenuItems: MenuProps['items'] = [
    {
      key: 'login',
      icon: <LoginOutlined />,
      label: '登录',
    },
  ];

  if (isAuthenticated && user) {
    return (
      <Dropdown
        menu={{
          items: authenticatedMenuItems,
          onClick: handleMenuClick,
        }}
        placement="bottomRight"
        arrow
      >
        <Button type="text" style={{ height: 'auto', padding: '4px 8px' }}>
          <Space>
            <Avatar size="small" icon={<UserOutlined />} />
            <span style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user.name || user.email.split('@')[0]}
            </span>
          </Space>
        </Button>
      </Dropdown>
    );
  }

  return (
    <Dropdown
      menu={{
        items: unauthenticatedMenuItems,
        onClick: handleMenuClick,
      }}
      placement="bottomRight"
      arrow
    >
      <Button type="primary" icon={<LoginOutlined />}>
        登录
      </Button>
    </Dropdown>
  );
};

export default UserMenu;